import type { ISystemParam } from '../interfaces/system-params';

export function booleanSystemParam(
  metadata: Pick<ISystemParam, 'id' | 'name' | 'description' | 'isProtected'>,
  value: unknown,
): ISystemParam {
  const known = typeof value === 'boolean';
  return {
    ...metadata,
    valueType: 'boolean',
    value: known ? String(value) : '',
    listValue: known ? (value ? 'Да' : 'Нет') : 'Недоступно',
    isProtected: metadata.isProtected || !known,
    minValue: null,
    maxValue: null,
    inputMask: '.',
    regexpMask: '',
  };
}
